import timeOutcomeOfInvitationsSbm from './time-outcomeOfInvitationsSbm';
import outcomeOfInvitationsSbmNone from './outcomeOfInvitationsSbm-none';
import reviewerResponseTimeDaysList from "./reviewerResponseTimeDays";
import timeNone from './time-none';
import revTypeOutcomeOfInvitations from './revtype-outcomeOfInvitations';
import revTypeOutcomeAgreedDeclined from './revtype-outcomeAgreedDeclined';

export default [...timeOutcomeOfInvitationsSbm, ...outcomeOfInvitationsSbmNone, ...reviewerResponseTimeDaysList, ...timeNone, ...revTypeOutcomeAgreedDeclined];
